exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".section[data-v-b4ae8e38]{text-align:left;margin:0 25px 80px}.section>.title[data-v-b4ae8e38]{line-height:30px;margin-bottom:20px}.section>.title>.caption[data-v-b4ae8e38]{font-size:18px}.section>.text[data-v-b4ae8e38]{margin-bottom:16px}.section>.image[data-v-b4ae8e38]{overflow:hidden;position:relative}.section>.image>img[data-v-b4ae8e38]{position:absolute}.section.is-improvement>.image[data-v-b4ae8e38]{height:242px}.section.is-shampoo>.image[data-v-b4ae8e38]{height:264px}.section.is-shampoo>.image>img[data-v-b4ae8e38]{top:-68px}.section.is-damageless>.image[data-v-b4ae8e38]{height:264px}.section.is-damageless>.image>img[data-v-b4ae8e38]{top:-190px}.section.is-onetoone>.image[data-v-b4ae8e38]{height:242px}.section.is-technical>.image[data-v-b4ae8e38]{height:210px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b4ae8e38","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Concept.vue
// module id = etRK
// module chunks = 1